import React, { useEffect, useState } from "react";
import { CustomStyledDataGrid } from "./CustomStyledDataGrid";

export const DynamicDataGrid = ({
  data,
  skipColumns,
  headers,
  height,
  width,
}) => {
  if (!skipColumns) {
    skipColumns = [];
  }
  const [tableHeaders, setTableHeaders] = useState([]);
  const getValue = (data, key) => {
    if (key == "lotno") {
      return data;
    }
    if (data === 0 || data === "0") return data;

    if (data === null || data === undefined || data === "") {
      return "";
    }

    //this fn takes a string and retuns a number (if possible) with 4 decimal places.
    //incase the number is whole number then it doesn't make it decimal.
    if (isNaN(data) === false) {
      return data === Math.floor(data) ? Number(data) : Number(data).toFixed(4);
    }
    return data;
  };
  useEffect(() => {
    if (headers && headers.length > 0) {
      setTableHeaders((prev) => headers);
      return;
    }

    if (data && data.length) {
      if (headers && headers.length) {
        setTableHeaders(headers);
        return;
      }

      setTableHeaders(
        Object.keys(data[0]).filter((key) => skipColumns.indexOf(key) === -1)
      );
    }
  }, [data, headers]);

  const rows = data.map((item, i) => {
    const row = { id: i + 1 }; // Assign a unique ID to each row
    tableHeaders.forEach((key) => {
      row[key] = getValue(item[key], key);
    });
    return row;
  });

  const columns = tableHeaders.map((header) => {
    if (header === "description") {
      return {
        field: header,
        headerName: header,
        minWidth: 300,
        flex: 3,
      };
    } else if (header === "available_qnty") {
      return {
        field: header,
        headerName: "Available Quantity",
        minWidth: 200,
        flex: 2,
      };
    } else {
      return {
        field: header,
        headerName: header,
        minWidth: 100,
        flex: 1,
      };
    }
  });

  return (
    <div className="w-full h-[65vh] mt-3">
      <CustomStyledDataGrid
        rows={rows}
        columns={columns}
        initialState={{
          ...data.initialState,
          pagination: { paginationModel: { pageSize: 30 } },
        }}
        rowHeight={40}
        pageSizeOptions={[30, 40, 50]}
      />
    </div>
  );
};
